import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicSubscriptionUpdateRequest {
  @jsonMember(Number)
  public readonly cardChargeDay!: number;

  public constructor(
    private readonly data: {
      cardChargeDay: number;
    },
  ) {
    this.cardChargeDay = this.data.cardChargeDay;
  }
}
